import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CreateJobNoteRequest, HttpResponse, JobNote } from "@/types";

export function useCreateJobNote() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      createJobNoteRequest,
    }: {
      createJobNoteRequest: CreateJobNoteRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-notes`;
      const res = await guacHttpClient.post<
        JobNote,
        HttpResponse<JobNote>,
        CreateJobNoteRequest
      >(path, createJobNoteRequest);

      return res.data;
    },
  });

  return mutation;
}
